import React, { useEffect, useRef, useState } from "react";
import Grid from "@material-ui/core/Grid";
import {
  getAutocompleteLabel,
  normalizeAutocompleteValue,
} from "../../../utils/autocomplete";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import "date-fns";
import { ca } from "date-fns/locale";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AddressField from "./AddressField";
//Estilos
const useStyles = makeStyles((theme) => {
  const responsiveControl = {
    width: `calc(100% - ${theme.spacing(2)}px)`,
    minWidth: 0,
    "& .MuiAutocomplete-root": { width: "100%" },
    "& .MuiFormControl-root": { width: "100%", minWidth: 0 },
    "& .MuiInputBase-root": { width: "100%" },
  };

  return {
    formControl: {
      margin: theme.spacing(1),
      minWidth: 850,
      [theme.breakpoints.down(1222)]: responsiveControl,
    },
    formControl2: {
      margin: theme.spacing(1),
      minWidth: 860,
      [theme.breakpoints.down(1222)]: responsiveControl,
    },
    formControl3: {
      margin: theme.spacing(1),
      minWidth: 420,
      [theme.breakpoints.down(1222)]: responsiveControl,
    },
    formControl31: {
      margin: theme.spacing(1),
      minWidth: 410,
      [theme.breakpoints.down(1222)]: responsiveControl,
    },
    formControl4: {
      margin: theme.spacing(1),
      minWidth: 300,
      [theme.breakpoints.down(1222)]: responsiveControl,
    },
    formControl5: {
      margin: theme.spacing(1),
      minWidth: 260,
      [theme.breakpoints.down(1222)]: responsiveControl,
    },
    formControl6: {
      margin: theme.spacing(2),
      minWidth: 300,
      [theme.breakpoints.down(1222)]: {
        ...responsiveControl,
        width: `calc(100% - ${theme.spacing(4)}px)`,
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    container: {
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
      minWidth: 0,
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end",
      flexWrap: "wrap",
    },
    button: {
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
  };
});

export default function ViajeDetalles(props) {
  const classes = useStyles();
  const filter = createFilterOptions();
  const [inputValue, setInputValue] = useState(""); // Estado para manejar el valor del input
  // Reutiliza tus helpers existentes (handlers, normalizadores, etc.)
  const geocoderRef = useRef(null);
  const autoSvcRef = useRef(null);
  const [preds, setPreds] = useState([]);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [pendingKeys, setPendingKeys] = useState({
    dirKey: null,
    coordsKey: null,
  });
  useEffect(() => {
    if (window.google?.maps) {
      if (!geocoderRef.current)
        geocoderRef.current = new window.google.maps.Geocoder();
      if (!autoSvcRef.current)
        autoSvcRef.current =
          new window.google.maps.places.AutocompleteService();
    }
  }, []);
  function choosePrediction(pred) {
    setPickerOpen(false);
    setPreds([]);
    const { dirKey, coordsKey } = pendingKeys || {};
    setPendingKeys({ dirKey: null, coordsKey: null });
    if (!pred?.place_id || !dirKey || !coordsKey) return;
    geocodePlaceId(pred.place_id, dirKey, coordsKey);
  }
  function suggestDireccion(dirKey, coordsKey) {
    const raw = (props.values[dirKey] || "").trim();
    if (!raw || raw.length < 8 || !autoSvcRef.current) return;

    autoSvcRef.current.getPlacePredictions(
      {
        input: raw,
        componentRestrictions: { country: ["es", "and"] },
        types: ["geocode"],
      },
      (predictions, status) => {
        const OK = window.google.maps.places.PlacesServiceStatus.OK;
        if (status !== OK || !predictions?.length) {
          // 0 sugerencias → geocode directo del texto y guardar coords
          geocodeAddressWithFallback(raw, dirKey, coordsKey);
          return;
        }

        if (predictions.length === 1) {
          // 1 sugerencia → geocode por placeId y guardar coords
          const p = predictions[0];
          geocodePlaceId(p.place_id, dirKey, coordsKey);
          return;
        }

        // >1 sugerencia → abrir selector (Dialog)
        setPendingKeys({ dirKey, coordsKey });
        setPreds(predictions.slice(0, 7));
        setPickerOpen(true);
      }
    );
  }
  function saveFromResult(r, dirKey, coordsKey) {
    if (!r?.geometry) return;
    const lat = r.geometry.location.lat();
    const lng = r.geometry.location.lng();
    props.handleDataDireccion(dirKey)(
      r.formatted_address || r.description || ""
    );
    props.handleDataCoordenadas(coordsKey)(`${lat},${lng}`);
  }
  function geocodePlaceId(placeId, dirKey, coordsKey) {
    if (!placeId || !geocoderRef.current) return;
    geocoderRef.current.geocode({ placeId }, (results, status) => {
      if (status === "OK" && results?.[0]) {
        saveFromResult(results[0], dirKey, coordsKey);
      } else {
      }
    });
  }
  function geocodeAddressWithFallback(raw, dirKey, coordsKey) {
    if (!geocoderRef.current) return;
    geocoderRef.current.geocode(
      { address: raw, componentRestrictions: { country: ["es", "and"] } },
      (results, st) => {
        if (st === "OK" && results?.[0]) {
          saveFromResult(results[0], dirKey, coordsKey);
        } else {
          geocoderRef.current.geocode(
            { address: raw, componentRestrictions: { country: "ad" } },
            (res2, st2) => {
              if (st2 === "OK" && res2?.[0]) {
                saveFromResult(res2[0], dirKey, coordsKey);
              } else {
              }
            }
          );
        }
      }
    );
  }
  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value); // Actualiza el valor del input
    props.handleDataDireccion("direccionDestino")(value); // Actualiza el estado con el valor del input
  };
  const handleChange1 = (e) => {
    const value = e.target.value;
    setInputValue(value); // Actualiza el valor del input
    props.handleDataDireccion("destino1direccionDestino")(value); // Actualiza el estado con el valor del input
  };
  const handleChange2 = (e) => {
    const value = e.target.value;
    setInputValue(value); // Actualiza el valor del input
    props.handleDataDireccion("destino2direccionDestino")(value); // Actualiza el estado con el valor del input
  };
  const handleChange3 = (e) => {
    const value = e.target.value;
    setInputValue(value); // Actualiza el valor del input
    props.handleDataDireccion("destino3direccionDestino")(value); // Actualiza el estado con el valor del input
  };
  const handleDestinoModificadoVuelta = (e) => {
    const value = e.target.value;
    setInputValue(value); // Actualiza el valor del input
    props.handleDataDireccion("direccionModificadoVuelta")(value); // Actualiza el estado con el valor del input
  };
  const handleChangeOrigen = (e) => {
    const value = e.target.value;
    setInputValue(value); // Actualiza el valor del input
    props.handleDataDireccion("origenDireccionModificada")(value); // Actualiza el estado con el valor del input
  };
  return (
    <React.Fragment>
      <Grid container spacing={3}>
        {/* INFORMACION VIAJE */}
        <Grid container>
          <Grid item xs={5}>
            <Typography variant="h6">Información del viaje</Typography>
          </Grid>
          {/* CHECKS DE PARAMETROS */}
          <Grid item xs={7}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.urgente}
                  onChange={(event) =>
                    props.handleUrgente(event.target.checked)
                  }
                />
              }
              label="Urgente"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.vacioAlta}
                  onChange={(event) => props.handleAlta(event.target.checked)}
                />
              }
              label="Alta"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.vacioVuelta}
                  onChange={(event) =>
                    props.handleIngreso(event.target.checked)
                  }
                />
              }
              label="Ingreso"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.origenModificado}
                  onChange={(event) =>
                    props.handleOrigenM(event.target.checked)
                  }
                />
              }
              label="Modificar Origen"
            />
          </Grid>
          {/* CLIENTE ,CENTROS */}
          <Grid item xs={12}>
            {typeof props.handleClientes === "function" ? (
              <FormControl className={classes.formControl3}>
              <Autocomplete
                value={normalizeAutocompleteValue(props.values.idClienteSol, "nombre")}
                onChange={(event, newValue) => {
                  if (typeof newValue == "string") {
                    props.handleClientes(newValue);
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    props.handleClientes(newValue.inputValue);
                  } else {
                    props.handleClientes(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Suggest the creation of a new value
                  if (params.inputValue !== "") {
                    filtered.push({
                      inputValue: params.inputValue,
                      nombre: `Usar: "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={props.values.clientes}
                getOptionLabel={(option) => getAutocompleteLabel(option, "nombre")}
                renderOption={(option) => option.nombre}
                // style={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Escribe el Cliente que solicita"
                    variant="outlined"
                  />
                )}
              />
              </FormControl>
            ) : (
              <Typography variant="body2" color="textSecondary" style={{ margin: 8 }}>
                El cliente solicitante se asigna automáticamente a tu cuenta.
              </Typography>
            )}
            <FormControl className={classes.formControl3}>
              <Autocomplete
                value={normalizeAutocompleteValue(props.values.direccionHospital)}
                onChange={(event, newValue) => {
                  if (typeof newValue == "string") {
                    props.handleCentros(newValue);
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    props.handleCentros(newValue.inputValue);
                  } else {
                    props.handleCentros(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Suggest the creation of a new value
                  if (params.inputValue !== "") {
                    filtered.push({
                      inputValue: params.inputValue,
                      title: `Usar: "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={props.values.todosCentros}
                getOptionLabel={(option) => getAutocompleteLabel(option)}
                renderOption={(option) => option.title}
                // style={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Escribe el Centro de Asistencia"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
        {props.values.origenModificado ? (
          <Grid container alignItems="center">
            {/* Primera fila: Título y checkboxes en la misma línea */}
            <Grid item xs={6}>
              <Typography variant="h6">Indicar Origen de la Mutua</Typography>
            </Grid>
            {props.values.vacioAlta === false ? (
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.values.origenModificadoP1}
                      onChange={(event) =>
                        props.handleOrigenModificadoP1(event.target.checked)
                      }
                    />
                  }
                  label="P1"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.values.origenModificadoP2}
                      onChange={(event) =>
                        props.handleOrigenModificadoP2(event.target.checked)
                      }
                    />
                  }
                  label="P2"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.values.origenModificadoP3}
                      onChange={(event) =>
                        props.handleOrigenModificadoP3(event.target.checked)
                      }
                    />
                  }
                  label="P3"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.values.origenModificadoP4}
                      onChange={(event) =>
                        props.handleOrigenModificadoP4(event.target.checked)
                      }
                    />
                  }
                  label="P4"
                />
              </Grid>
            ) : (
              <></>
            )}

            {/* Segunda fila: Otros campos de formulario */}
            <Grid item xs={12}>
              <FormControl className={classes.formControl3}>
                <Autocomplete
                  value={normalizeAutocompleteValue(props.values.origenPuebloModificado)}
                  onChange={(event, newValue) => {
                    if (typeof newValue == "string") {
                      props.handleOrigenModificado(newValue);
                    } else if (newValue && newValue.inputValue) {
                      // Crear un nuevo valor a partir del input del usuario
                      props.handleOrigenModificado(newValue.inputValue);
                    } else {
                      props.handleOrigenModificado(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    // Sugiere la creación de un nuevo valor
                    if (params.inputValue !== "") {
                      filtered.push({
                        inputValue: params.inputValue,
                        title: `Usar: "${params.inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={props.values.todosDestinos}
                  getOptionLabel={(option) => getAutocompleteLabel(option)}
                  renderOption={(option) => option.title}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Escribe un pueblo de Origen Modificado"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
              <FormControl className={classes.formControl3}>
                <AddressField
                  label="Dirección Origen Modificado"
                  dirKey="origenDireccionModificada"
                  coordsKey="origenCoordenadaModificada"
                  value={props.values.origenDireccionModificada}
                  onChange={handleChangeOrigen}
                  suggestDireccion={suggestDireccion}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <FormControl className={classes.formControl3}>
            <TextField
              value={props.values.identificadorIda}
              required
              id="city"
              name="city"
              label="Identificador Ida"
              fullWidth
              autoComplete="shipping address-level2"
              onChange={props.handleData("identificadorIda")}
              inputProps={{
                maxLength: 40,
              }}
            />
          </FormControl>
          <FormControl className={classes.formControl3}>
            <TextField
              value={props.values.identificadorVuelta}
              id="city"
              name="city"
              label="Identificador Vuelta"
              fullWidth
              autoComplete="shipping address-level2"
              onChange={props.handleData("identificadorVuelta")}
              inputProps={{
                maxLength: 40,
              }}
            />
          </FormControl>
        </Grid>
        {/* TITULO DESTINO Y CHECKS */}
        <Grid container>
          <Grid item xs={5}>
            <Typography variant="h6">Destinos</Typography>
          </Grid>
          {/* CHECKS DESTINOS */}
          <Grid item xs={7}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.destino1}
                  onChange={(event) =>
                    props.handleDestino1(event.target.checked)
                  }
                />
              }
              label="D 1"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.destino2}
                  onChange={(event) =>
                    props.handleDestino2(event.target.checked)
                  }
                />
              }
              label="D 2"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.destino3}
                  onChange={(event) =>
                    props.handleDestino3(event.target.checked)
                  }
                />
              }
              label="D 3"
            />
            {props.values.vacioVuelta === false ? (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.values.destinoModificado}
                    onChange={(event) =>
                      props.handleDestinoM(event.target.checked)
                    }
                  />
                }
                label="Modificar Destino Vuelta"
              />
            ) : (
              <></>
            )}
          </Grid>
          {/* DESTINO NORMAL */}
          {!props.values.vacioAlta ? (
            <Grid item xs={12}>
              <FormControl className={classes.formControl3}>
                <Autocomplete
                  value={normalizeAutocompleteValue(props.values.destino)}
                  onChange={(event, newValue) => {
                    if (typeof newValue == "string") {
                      props.handleDestino(newValue);
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      props.handleDestino(newValue.inputValue);
                    } else {
                      props.handleDestino(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    // Suggest the creation of a new value
                    if (params.inputValue !== "") {
                      filtered.push({
                        inputValue: params.inputValue,
                        title: `Usar: "${params.inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={props.values.todosDestinos}
                  getOptionLabel={(option) => getAutocompleteLabel(option)}
                  renderOption={(option) => option.title}
                  // style={{ width: 300 }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Escribe un pueblo destino"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
              <FormControl className={classes.formControl3}>
                <AddressField
                  label="Dirección Destino"
                  dirKey="direccionDestino"
                  coordsKey="coordenadasDestino"
                  value={props.values.direccionDestino}
                  onChange={handleChange} // tu handler existente
                  suggestDireccion={suggestDireccion} // la función de la lupa (predicciones + geocode)
                />
              </FormControl>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
        {/* CONDICIONALES DE DESTINOS */}
        {props.values.destino1 ? (
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Destino 1 adicional
            </Typography>
            <Grid item xs={12}>
              <FormControl className={classes.formControl3}>
                <Autocomplete
                  value={normalizeAutocompleteValue(props.values.destino1Destino)}
                  onChange={(event, newValue) => {
                    if (typeof newValue == "string") {
                      props.handleDestinoViaje1(newValue);
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      props.handleDestinoViaje1(newValue.inputValue);
                    } else {
                      props.handleDestinoViaje1(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    // Suggest the creation of a new value
                    if (params.inputValue !== "") {
                      filtered.push({
                        inputValue: params.inputValue,
                        title: `Usar: "${params.inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={props.values.todosDestinos}
                  getOptionLabel={(option) => getAutocompleteLabel(option)}
                  renderOption={(option) => option.title}
                  // style={{ width: 300 }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Escribe un pueblo destino"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
              <FormControl className={classes.formControl3}>
                <AddressField
                  label="Dirección Destino"
                  dirKey="destino1direccionDestino"
                  coordsKey="destino1coordenadasDestino"
                  value={props.values.destino1direccionDestino}
                  onChange={handleChange1}
                  suggestDireccion={suggestDireccion}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : null}
        {props.values.destino2 ? (
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Destino 2 adicional
            </Typography>
            <Grid item xs={12}>
              <FormControl className={classes.formControl3}>
                <Autocomplete
                  value={normalizeAutocompleteValue(props.values.destino2Destino)}
                  onChange={(event, newValue) => {
                    if (typeof newValue == "string") {
                      props.handleDestinoViaje2(newValue);
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      props.handleDestinoViaje2(newValue.inputValue);
                    } else {
                      props.handleDestinoViaje2(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    // Suggest the creation of a new value
                    if (params.inputValue !== "") {
                      filtered.push({
                        inputValue: params.inputValue,
                        title: `Usar: "${params.inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={props.values.todosDestinos}
                  getOptionLabel={(option) => getAutocompleteLabel(option)}
                  renderOption={(option) => option.title}
                  // style={{ width: 300 }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Escribe un pueblo destino"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
              <FormControl className={classes.formControl3}>
                <AddressField
                  label="Dirección Destino"
                  dirKey="destino2direccionDestino"
                  coordsKey="destino2coordenadasDestino"
                  value={props.values.destino2direccionDestino}
                  onChange={handleChange2}
                  suggestDireccion={suggestDireccion}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : null}
        {props.values.destino3 ? (
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Destino 3 adicional
            </Typography>
            <Grid item xs={12}>
              <FormControl className={classes.formControl3}>
                <Autocomplete
                  value={normalizeAutocompleteValue(props.values.destino3Destino)}
                  onChange={(event, newValue) => {
                    if (typeof newValue == "string") {
                      props.handleDestinoViaje3(newValue);
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      props.handleDestinoViaje3(newValue.inputValue);
                    } else {
                      props.handleDestinoViaje3(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    // Suggest the creation of a new value
                    if (params.inputValue !== "") {
                      filtered.push({
                        inputValue: params.inputValue,
                        title: `Usar: "${params.inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={props.values.todosDestinos}
                  getOptionLabel={(option) => getAutocompleteLabel(option)}
                  renderOption={(option) => option.title}
                  // style={{ width: 300 }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Escribe un pueblo destino"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
              <FormControl className={classes.formControl3}>
                <AddressField
                  label="Dirección Destino"
                  dirKey="destino3direccionDestino"
                  coordsKey="destino3coordenadasDestino"
                  value={props.values.destino3direccionDestino}
                  onChange={handleChange3}
                  suggestDireccion={suggestDireccion}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : null}
        {props.values.destinoModificado ? (
          <Grid container alignItems="center">
            <Grid item xs={6}>
              <Typography variant="h6">Destino Vuelta Modificado</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.values.destinoModificadoP1}
                    onChange={(event) =>
                      props.handleDestinoModificadoP1(event.target.checked)
                    }
                  />
                }
                label="P1"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.values.destinoModificadoP2}
                    onChange={(event) =>
                      props.handleDestinoModificadoP2(event.target.checked)
                    }
                  />
                }
                label="P2"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.values.destinoModificadoP3}
                    onChange={(event) =>
                      props.handleDestinoModificadoP3(event.target.checked)
                    }
                  />
                }
                label="P3"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.values.destinoModificadoP4}
                    onChange={(event) =>
                      props.handleDestinoModificadoP4(event.target.checked)
                    }
                  />
                }
                label="P4"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl className={classes.formControl3}>
                <Autocomplete
                  value={normalizeAutocompleteValue(props.values.destinoModificadoVuelta)}
                  onChange={(event, newValue) => {
                    if (typeof newValue == "string") {
                      props.handleDestinoVueltaModificado(newValue);
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      props.handleDestinoVueltaModificado(newValue.inputValue);
                    } else {
                      props.handleDestinoVueltaModificado(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    // Suggest the creation of a new value
                    if (params.inputValue !== "") {
                      filtered.push({
                        inputValue: params.inputValue,
                        title: `Usar: "${params.inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={props.values.todosDestinos}
                  getOptionLabel={(option) => getAutocompleteLabel(option)}
                  renderOption={(option) => option.title}
                  // style={{ width: 300 }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Escribe un pueblo destino"
                      variant="outlined"
                    />
                  )}
                />
              </FormControl>
              <FormControl className={classes.formControl3}>
                <AddressField
                  label="Dirección Destino Vuelta (Modificado)"
                  dirKey="direccionModificadoVuelta"
                  coordsKey="coordenadasdestinoModificadoVuelta"
                  value={props.values.direccionModificadoVuelta}
                  onChange={handleDestinoModificadoVuelta}
                  suggestDireccion={suggestDireccion}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : null}
        {/* REHABILITACION TIPO SESIONES */}
        <Grid item xs={12}>
          <FormControlLabel
            className={classes.formControl5}
            control={
              <Checkbox
                checked={props.values.rehabilitacion}
                onChange={(event) =>
                  props.handleRehabilitacion(event.target.checked)
                }
              />
            }
            label="Re-habilitacion"
          />
          <FormControl className={classes.formControl5}>
            <TextField
              required
              id="city"
              name="city"
              type="number"
              label="Cuando dias realizaremos el servició"
              fullWidth
              value={props.values.sesiones}
              onChange={props.handleData("sesiones")}
            />
          </FormControl>
          <FormControl className={classes.formControl4}>
            <InputLabel id="demo-simple-select-label">
              Selecciona el tipo de vehículo
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={props.values.tipo}
              name="tipo"
              onChange={(e) => props.handleVehiculo(e.target.value)}
            >
              <MenuItem value={"TURISME"}>TURISME</MenuItem>
              <MenuItem value={"ADAPTAT"}>ADAPTAT</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {/* SELECT DATAS */}
        <Grid item xs={12} container justify="space-between">
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ca}>
            <KeyboardDatePicker
              fullWidth
              margin="normal"
              id="date-picker-dialog"
              label="Selecciona una fecha"
              format="dd/MM/yyyy"
              value={props.values.fecha}
              onChange={(date) => props.handleConfirm(date, "Fecha")}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
            <KeyboardTimePicker
              fullWidth
              margin="normal"
              id="time-picker"
              label="Selecciona una hora"
              ampm={false}
              value={props.values.hora}
              onChange={(date) => props.handleConfirm(date, "Hora")}
              KeyboardButtonProps={{
                "aria-label": "change time",
              }}
            />
          </MuiPickersUtilsProvider>
          <FormControl className={classes.formControl6}>
            <TextField
              id="city"
              name="city"
              disabled
              label="Seleccionaste:"
              fullWidth
              autoComplete="shipping address-level2"
              value={props.values.fechaMostrar}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Dialog
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <List>
          {preds.map((p) => (
            <ListItem
              button
              key={p.place_id}
              onClick={() => choosePrediction(p)}
            >
              <ListItemText
                primary={p.structured_formatting?.main_text || p.description}
                secondary={p.structured_formatting?.secondary_text || ""}
              />
            </ListItem>
          ))}
        </List>
      </Dialog>
      <div className={classes.buttons}>
        {Number(props.activeStep) !== 0 && (
          <Button onClick={props.prevStep} className={classes.button}>
            Regresar
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={props.nextStep}
          className={classes.button}
        >
          {Number(props.activeStep) === 4 && props.activeStep < 5
            ? "Solicitar viaje"
            : "Siguiente"}
        </Button>
      </div>
    </React.Fragment>
  );
}
